import { MDBSelect } from "mdb-react-ui-kit";
import React from "react";
import { useTranslation } from "react-i18next";
import { formattedNumber } from "../../../views/popups/phonenumbers/AddRemoveNumbers";

function LocEmerNineOO({
  register,
  setValue,
  getValues,
  errors,
  dedicatedNineOneNumbers,
}) {
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className="margin-top">
        <div className="general-settings">{t("emergency911")}</div>
        <div className="add-numbermain">
          <div className="tel-numbers">{t("emerg911txt")}</div>
          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              <select
                className="form-control form-select selectname w-100"
                name="--Select a Dedicated number for 911--"
                {...register("nine_one_one.dedicated_nine_one_one_number")}
              >
                <option
                  value={getValues(
                    "nine_one_one.dedicated_nine_one_one_number"
                  )}
                >
                  {getValues("nine_one_one.dedicated_nine_one_one_number")}
                </option>
                {dedicatedNineOneNumbers &&
                  Object.entries(dedicatedNineOneNumbers).map(
                    ([key, value]) => <option value={parseInt(key)}>{formattedNumber(value)}</option>
                  )}
              </select>
              {errors.nine_one_one?.dedicated_nine_one_one_number && (
                <p className="text-danger">
                  {errors.nine_one_one.dedicated_nine_one_one_number.message}
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="add-numbermain">
          <div className="tel-numbers">{t("Speclocation")}</div>
          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              <input
                type="text"
                className="form-control selectname"
                {...register("nine_one_one.specific_location")}
              />
              {errors.nine_one_one?.specific_location && (
                <p className="text-danger">
                  {errors.nine_one_one.specific_location.message}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LocEmerNineOO;
